import { DetailedHTMLProps, InputHTMLAttributes } from "react";

export type UICheckboxProps = {
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "checked" | "onChange" | "type"
>;

export const UICheckbox = ({
  isChecked,
  onChange,
  ...checkboxProps
}: UICheckboxProps) => (
  <div className="checkboxField">
    <input
      type="checkbox"
      checked={isChecked}
      onChange={onChange}
      {...checkboxProps}
    />
    <svg
      width="32"
      height="32"
      viewBox="-4 -4 39 39"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        className="checkbox__bg"
        width="35"
        height="35"
        x="-2"
        y="-2"
        stroke="currentColor"
        fill="white"
        strokeWidth="3"
      />
      <polyline
        className="checkbox__checkmark"
        points="4,14 12,23 28,5"
        stroke="transparent"
        strokeWidth="4"
        fill="none"
      />
    </svg>
  </div>
);
